import React from 'react'
import PropTypes from 'prop-types'
import styled, { theme } from '@nobia/zeus-components/lib/styled'
import { Link } from '@nobia/zeus-components/lib/router'

const StyledLink = styled(Link)`
  background-color: ${theme('productNavigationButton.backgroundColor')};
  border-radius: ${theme('productNavigationButton.borderRadiusLeft')};
  color: ${theme('productNavigationButton.color')};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.625em 0.43em;
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: opacity 0.1s ease;

  :hover {
    opacity: 0.72;
  }
  & + &,
  & + div {
    left: auto;
    right: 0;
    border-radius: ${theme('productNavigationButton.borderRadiusRight')};
  }

  ${(props) => props.theme.media.max.sm`
      display: none;
  `};
`

const DisabledLink = styled.div`
  background-color: ${theme('productNavigationButton.backgroundColor')};
  border-radius: ${theme('productNavigationButton.borderRadiusLeft')};
  color: ${theme('productNavigationButton.color')};
  display: flex;
  opacity: ${theme('productNavigationButton.opacity')};
  justify-content: center;
  align-items: center;
  width: 58px;
  height: 78px;
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);

  & + a {
    left: auto;
    right: 0;
    border-radius: ${theme('productNavigationButton.borderRadiusRight')};
  }

  ${(props) => props.theme.media.max.sm`
        display: none;
    `};
`

const ProductNavigationButton = ({ title, url, children, isDisabled }) =>
  !isDisabled ? (
    <StyledLink to={`../../../${url}/`} aria-label={title}>
      {children}
    </StyledLink>
  ) : (
    <DisabledLink>{children}</DisabledLink>
  )

ProductNavigationButton.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
}

ProductNavigationButton.defaultProps = {
  isDisabled: false,
}

export default ProductNavigationButton
